const CODIGO_TIPO_EQUIPE_NASF = '72'

export function isTipoEquipeEmulti(codigoMs: string): boolean {
  return codigoMs === CODIGO_TIPO_EQUIPE_NASF
}
